import { FeecodeGet } from "@kase/my-marathon-communication";
import { ApiSliceParams } from "../interfaces";
import { createListController } from "../utils";
import { FeeCode } from "./interfaces";

export const makeFeeCode = ({ connection, company }: ApiSliceParams) => {
    const {
        items: codes,
        allLoading: loading,
        allLoaded: loaded,
        listen,
        get,
        getOrLoad,
    } = createListController<FeecodeGet, FeeCode>({
        name: "feecode",
        connection,
        list: (con) => con.feecode.items({ company: company.value }),
    });

    return { codes, loading, loaded, get, getOrLoad, listen };
};
